import type { WallpaperConfig } from '../config/schema';

interface DotProps {
  cx: number;
  cy: number;
  r: number;
  color: string;
  shape: WallpaperConfig['shape'];
}

export function Dot({ cx, cy, r, color, shape }: DotProps) {
  if (shape === 'square') {
    return <rect x={cx - r} y={cy - r} width={r * 2} height={r * 2} fill={color} />;
  }
  return <circle cx={cx} cy={cy} r={r} fill={color} />;
}
